module.exports = __webpack_public_path__ + "static/media/aboutUs3.d64dbddb.jpg";